import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './audit-history.reducer';
import { IAuditHistory } from 'app/shared/model/audit-history.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IAuditHistoryDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const AuditHistoryDetail = (props: IAuditHistoryDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { auditHistoryEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          AuditHistory [<b>{auditHistoryEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="videoOriginalJson">Video Original Json</span>
          </dt>
          <dd>{auditHistoryEntity.videoOriginalJson}</dd>
          <dt>
            <span id="videoNewJson">Video New Json</span>
          </dt>
          <dd>{auditHistoryEntity.videoNewJson}</dd>
          <dt>
            <span id="updatedBy">Updated By</span>
          </dt>
          <dd>{auditHistoryEntity.updatedBy}</dd>
          <dt>
            <span id="updatedOn">Updated On</span>
          </dt>
          <dd>
            {auditHistoryEntity.updatedOn ? (
              <TextFormat value={auditHistoryEntity.updatedOn} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/audit-history" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/audit-history/${auditHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ auditHistory }: IRootState) => ({
  auditHistoryEntity: auditHistory.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AuditHistoryDetail);
